export default {
    data() {
        return {
        };
    },
    methods: {
        openModalIframe() {
            this.$refs["modal-iframe"].toggleModal();
        },
        toggleActiveIframeModalInterval() {
            this.activeIframeModalInterval = !this.activeIframeModalInterval;
        },
    },
};
